<template>
  <div class="disc-wrap margin-horizontal">
    <div class="disc-title">{{ $t('home.discovery.title') }}</div>
    <div class="disc-grid">
      <div
        v-for="item in items"
        :key="item.id"
        class="disc-item"
        @click="onSelect(item)"
      >
        <div class="disc-icon" :class="'disc-icon--' + item.color">
          <f7-icon :f7="item.icon" size="18" />
        </div>
        <span class="disc-label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { f7 } from 'framework7-vue'
import i18n from '../../js/i18n.js'
import { useKeycloakStore } from '../../js/pinia-stores/keycloak.js'

const { t } = i18n.global

const keycloakStore = useKeycloakStore()

const items = computed(() => [
  { id: 'group', icon: 'person_2_fill', color: 'green', label: t('home.discovery.group'), route: '/groups/new' },
  { id: 'cause', icon: 'heart_fill', color: 'purple', label: t('home.discovery.cause'), route: '/causes/new' },
  { id: 'shops', icon: 'bag_fill', color: 'gold', label: t('home.discovery.shops'), route: '/stores/' },
  { id: 'events', icon: 'calendar_fill', color: 'blue', label: t('home.discovery.events'), route: '/events/' },
])

function onSelect(item) {
  if (item.route) {
    f7.views.main.router.navigate(item.route)
    return
  }
  keycloakStore.keycloak.register()
}
</script>

<style scoped>
.disc-wrap {
  margin-bottom: 16px;
}
.disc-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--f7-on-surface-variant, #8e8e93);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin: 0 0 8px;
  padding: 0 4px;
}
.disc-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
}
.disc-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.15s;
}
.disc-item:active {
  background: var(--f7-surface-container, #f5f5f5);
}
.disc-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.disc-icon--green {
  background: var(--avocash-green-light, #EAF2EB);
  color: var(--f7-theme-color, #1A6B42);
}
.disc-icon--purple {
  background: var(--avocash-purple-light, #F5F0FF);
  color: var(--f7-purple, #6B46C1);
}
.disc-icon--gold {
  background: var(--avocash-gold-light, #FDF6E3);
  color: var(--f7-secondary, #C9A84C);
}
.disc-icon--blue {
  background: var(--avocash-blue-light, #EBF0FC);
  color: var(--f7-blue, #3B4FCA);
}
.disc-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--f7-on-surface, #000);
}
</style>